import {Organization} from './organization'

export const ChargeOption: Record<string, string> = {
    '01': '월정액 자동충전',
    '02': '기준하한 자동충전',
    '99': '기타',
}

/**
 * 선불자동충전조회 api
 * @see http://myasset-api-alpha.fams.svc.xed1.io.navercorp.com/docs/index.html#_%EC%84%A0%EB%B6%88_%EC%9E%90%EB%8F%99%EC%B6%A9%EC%A0%84%EC%A0%95%EB%B3%B4_%EC%A1%B0%ED%9A%8C_api
 */
export interface PrepaidCharge {
    id: number
    nidNo: string
    asset: {
        id: number
        name: string
        nickname: string
        num: string
        seqno: string
        org: Organization
    }
    content: {
        accountId?: string
        chargeOrgCode?: string
        chargeAccountNum?: string
        chargeOption: keyof typeof ChargeOption
        chargeDay?: string
        chargeBaseAmt?: number
        chargeAmt?: number
    }
    createAt: string
    updateAt: string
}
